
            const data = {"name":"icon-arrow-medium","data":{"width":"19","height":"32","viewBox":"0 0 19 32","data":"<path pid=\"0\" _fill=\"currentColor\" d=\"M16.799 15.201a1.13 1.13 0 11-1.597 1.597L1.226 2.822a1.13 1.13 0 111.597-1.597l13.976 13.976z\"/><path pid=\"1\" _fill=\"currentColor\" d=\"M15.201 15.201a1.13 1.13 0 111.597 1.597L2.822 30.774a1.13 1.13 0 11-1.597-1.597l13.976-13.976z\"/>"}}
        
                module.exports = data
                